import { DataStore } from '../stores';

export const fundListFilter = (
    config: { key: string },
    dataStore: DataStore,
    shareClass
) => {
    const fund = shareClass.clientCode;
    const linkFilter: any = dataStore.linkFilter;
    // make sure a unqiue key is set up
    const key = config.key;

    if (linkFilter && linkFilter[key]) {
        return linkFilter[key].indexOf(fund) > -1;
    }
    return true;
};



// WEBPACK FOOTER //
// ./src/utils/fundListFilter.ts